import { Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { HttpClient } from "@angular/common/http";
import { HttpHeaders} from "@angular/common/http";
import {environment} from "../../../../environments/environment";

const httpHeaders: HttpHeaders = new HttpHeaders({
  "Access-Control-Allow-Origin": "*",
 "Content-Type": "application/json" 
});

@Injectable({
  providedIn: 'root'
})

export class SettingsService {

  constructor(private http: HttpClient) {}

  getInstallments(storeId:number): Observable<any> {
    return this.http.get(`${environment.openpayLambdaUrl}/merchant-params/${storeId}`);
  }

  updateMerchantsParams(body): Observable<any> {
    return this.http.post(`${environment.openpayLambdaUrl}/update-merchant-params`, body, {headers: httpHeaders});
  }
}
